import React from "react";
// import Header from "./components/Layouts/Header";
// import Section from "./components/Layouts/Section";
// adi's protfolio:    http://aditya664.me/index.html
// homepage animation: https://hashirshoaeb.com/home/
import Header from "./components/Layouts/header/Header";
import Nav from "./components/Layouts/nav/Nav";
import About from './components/Layouts/about/About';
import Experience from './components/Layouts/experience/Experience';
import Services from './components/Layouts/services/Services';
import Portfolio from './components/Layouts/portfolio/Portfolio';
import Testimonial from './components/Layouts/testimonial/Testimonial';
import Contact from './components/Layouts/contact/Contact';
import Footer from './components/Layouts/footer/Footer';

const App = () => {
    return (
        // <div>
        //     <Header />
        //     <Section />
        // </div>
        <>
        <Header/>
        <Nav/>
        <About/>
        <Experience/>
        <Services/>
        <Portfolio/>
        {/*<Testimonial/>*/}
        <Contact/>
        <Footer/>
            </>
            
    );
}

export default App;
